import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProjectContractor } from '../objects/Project'; // Import your data model
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectContractorService {
  private apiUrl = environment.apiUrl +'ProjectContractors'; // Replace with your API endpoint

  constructor(private http: HttpClient) { }

  getProjectContractors(): Observable<ProjectContractor[]> {
    return this.http.get<ProjectContractor[]>(this.apiUrl);
  }

  getProjectContractor(id: number): Observable<ProjectContractor> {
    return this.http.get<ProjectContractor>(`${this.apiUrl}/${id}`);
  }

  addProjectContractor(ProjectContractor: ProjectContractor): Observable<ProjectContractor> {
    return this.http.post<ProjectContractor>(this.apiUrl, ProjectContractor);
  }
  deleteProjectContractor(ProjectContractor: ProjectContractor): Observable<ProjectContractor> {
    const url = `${this.apiUrl}/${ProjectContractor.id}`;
    return this.http.delete<ProjectContractor>(url);
  }
  updateProjectContractor(ProjectContractor: ProjectContractor): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${ProjectContractor.id}`, ProjectContractor,
    {
      headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      }
    );
    }
  // updateProjectContractor(ProjectContractor: ProjectContractor): Observable<void> {
  //   return this.http.put<void>(`${this.apiUrl}/${ProjectContractor.id}`, ProjectContractor);

    
  // }
  // Other CRUD methods
}
